<section
    class="sr-app-light:bg-white flex-column flex max-h-full grow bg-[#F4F5F8] dark:bg-black md:flex-row md:overflow-hidden">
    <div
        class="relative flex w-full flex-col md:h-full md:max-w-[25rem]"
        [ngClass]="{ 'flex-grow': !isItineraryDetailPageActive }">
        <router-outlet></router-outlet>
    </div>

    <div
        class="relative flex grow flex-col"
        [ngClass]="{
            'hidden md:flex': !isItineraryDetailPageActive,
            'w-full': isItineraryDetailPageActive
        }">
        <ng-container [ngTemplateOutlet]="journeyPlannerMap"></ng-container>
    </div>

    <div
        class="space-safe-area pointer-events-none absolute ml-2.5 flex h-10 w-10 items-center justify-center rounded-full bg-white opacity-0"
        [attr.aria-hidden]="(showFullMap$ | async) === false"
        [ngClass]="{
            'pointer-events-auto z-10 opacity-100 transition-all duration-300 ease-in-out': showFullMap$ | async
        }">
        <ion-button
            class="mt-[1px] text-xs font-bold normal-case text-secondary dark:text-contrast-yellow print:hidden"
            [attr.aria-label]="'LOCAL_BTN_BACK' | translate"
            (click)="backToViewMap()"
            fill="clear">
            <ion-icon
                class="vl-app-light:w-5 vl-app-light:h-5 vl-app-light:mt-1 mx-1 h-6 w-6 text-xl dark:filter-yellow"
                [title]="'LOCAL_BTN_BACK' | translate"
                attr.aria-label="{{ 'LOCAL_BTN_BACK' | translate }}"
                src="{{ assetsPath$ | async }}/img/journey-planner/icon-arrow.svg"></ion-icon>
        </ion-button>
    </div>
</section>

<ng-template #journeyPlannerMap>
    <rwidget-map
        class="flex grow flex-col print:hidden"
        [class.space-safe-zone]="env.IS_MOBILE_APP && (showFullMap$ | async)"
        [latitude]="mapCenter?.latitude"
        [longitude]="mapCenter?.longitude"
        [allowPointClick]="true"
        [hasViewSettingsControl]="true"
        (click)="showFullMap()"
        (pointClicked)="onPointClicked($event)"
        (mapReady)="onMapReady()"
        (zoomChanged)="onZoomChanged($event)">
        <rwidget-map-popup *ngIf="!(search$ | async)?.disabled">
            <mat-nav-list class="bg-white p-0">
                <mat-list-item (click)="onDepartureClicked()">
                    <div mat-line>{{ 'SCHEDULE_SET_AS_DEPARTURE' | translate }}</div>
                    <mat-icon>chevron_right</mat-icon>
                </mat-list-item>
                <mat-divider></mat-divider>
                <mat-list-item (click)="onDestinationClicked()">
                    <div mat-line>{{ 'SCHEDULE_SET_AS_DESTINATION' | translate }}</div>
                    <mat-icon>chevron_right</mat-icon>
                </mat-list-item>
            </mat-nav-list>
        </rwidget-map-popup>
        <ng-template #originAndDestinationTemplate>
            <rwidget-map-marker
                *ngIf="originMarkerCoordinate"
                [latitude]="originMarkerCoordinate?.lat"
                [longitude]="originMarkerCoordinate?.lng"
                [isSingle]="true">
                <rwidget-map-icon
                    class="text-grey-dark dark:text-contrast-black"
                    [url]="iconOrigin"
                    [size]="[22, 22]"
                    [anchor]="[10, 10]">
                </rwidget-map-icon>
            </rwidget-map-marker>
            <rwidget-map-marker
                *ngIf="destinationMarkerCoordinate"
                [latitude]="destinationMarkerCoordinate?.lat"
                [longitude]="destinationMarkerCoordinate?.lng"
                [isSingle]="true">
                <rwidget-map-icon [url]="iconDestination" [size]="[20, 28]" [anchor]="[10, 28]"> </rwidget-map-icon>
            </rwidget-map-marker>
        </ng-template>
        <rwidget-map-layer-group
            *ngIf="(originMarkerCoordinate || destinationMarkerCoordinate) && !mapJourneyPlan"
            [label]="'JOURNEY_PLAN' | translate">
            <ng-container *ngTemplateOutlet="originAndDestinationTemplate"></ng-container>
        </rwidget-map-layer-group>
        <rwidget-map-layer-group *ngIf="mapJourneyPlan" [label]="'JOURNEY_PLAN' | translate" [fit]="true">
            <ng-container *ngTemplateOutlet="originAndDestinationTemplate"></ng-container>
            <ng-container *ngFor="let leg of mapJourneyPlan?.legs ?? []; let i = index">
                <rwidget-map-polyline
                    [encodedPath]="leg.polyline"
                    [weight]="zoomIconSizeValue === IconSizeEnum.large ? 6 : 4"
                    [style]="leg.polylineStyle"
                    [color]="leg.color"></rwidget-map-polyline>

                <rwidget-map-marker-group
                    *ngIf="zoomIconSizeValue !== IconSizeEnum.small"
                    [markers]="leg.markers"
                    [iconZoomSize]="zoomIconSizeValue"
                    (markerClicked)="onPlanStopClick($event)"
                    deleteOld="true">
                    <rwidget-map-icon
                        [size]="[mapIcons?.[MarkerType.stopNode]?.size, mapIcons?.[MarkerType.stopNode]?.size]"
                        [anchor]="[
                            mapIcons?.[MarkerType.stopNode]?.anchor[0],
                            mapIcons?.[MarkerType.stopNode]?.anchor[1]
                        ]"
                        [popupAnchor]="[0, -10]"
                        [forceContentClone]="true">
                        <div
                            class="h-full w-full rounded-full border-[3px] border-solid bg-white dark:border-contrast-black"
                            [style.border-color]="(isContrast$ | async) === false ? leg.color : null"
                            [style.background-color]="env.APP_NAME === 'vastmanland-app' ? leg?.color : 'white'"></div>
                    </rwidget-map-icon>

                    <rwidget-map-popup>
                        <div class="popup-title text-base">
                            <p class="text-base dark:!text-black">
                                {{ journeyPlanClickedStop?.name }}
                            </p>
                            <p class="text-base dark:!text-black" *ngIf="journeyPlanClickedStop?.code">
                                {{ journeyPlanClickedStop?.code }}
                            </p>
                            <p class="text-base dark:!text-black" *ngIf="journeyPlanClickedStop?.departureClockTime">
                                {{ 'DEPARTURE' | translate }}:
                                {{ journeyPlanClickedStop.departureClockTime | momentDate: 'HH:mm' : env.TIMEZONE }}
                            </p>
                            <p class="text-base dark:!text-black" *ngIf="journeyPlanClickedStop?.arrivalClockTime">
                                {{ 'ARRIVAL' | translate }}:
                                {{ journeyPlanClickedStop.arrivalClockTime | momentDate: 'HH:mm' : env.TIMEZONE }}
                            </p>
                        </div>
                    </rwidget-map-popup>
                </rwidget-map-marker-group>
            </ng-container>
        </rwidget-map-layer-group>

        <rwidget-map-layer-group [label]="'SCHEDULE_BUSES_LAYER' | translate" name="schedule-buses">
            <rwidget-map-marker *ngFor="let bus of busLocation" [latitude]="bus.latitude" [longitude]="bus.longitude">
                <rwidget-map-icon
                    [size]="[mapIcons?.[MarkerType.bus]?.size, mapIcons?.[MarkerType.bus]?.size]"
                    [anchor]="[mapIcons?.[MarkerType.bus]?.anchor[0], mapIcons?.[MarkerType.bus]?.anchor[1]]">
                    <rwidget-map-bus-icon
                        [isBusSelected]="true"
                        [zoomSize]="zoomIconSizeValue"
                        [bus]="bus"></rwidget-map-bus-icon>
                </rwidget-map-icon>
            </rwidget-map-marker>
        </rwidget-map-layer-group>

        <rwidget-map-layer-group
            *ngIf="formattedStops.length && (env.JOURNEY_PLANNER?.ALWAYS_SHOW_STOPS_TOGGLE || mapJourneyPlan === null)"
            [label]="'SCHEDULE_STOPS_LAYER' | translate"
            name="schedule-stops">
            <ng-container *ngIf="assetsPath$ | async as assetsPath">
                <!-- Formatted Stops -->
                <rwidget-map-marker-group
                    *ngIf="IconSizeOrderEnum[zoomIconSizeValue] >= IconSizeOrderEnum[stopsVisibleFromZoomSize]"
                    [markers]="formattedStops"
                    [iconZoomSize]="zoomIconSizeValue"
                    [deleteOld]="true"
                    (markerClicked)="onStopClicked($event)">
                    <rwidget-map-icon
                        [preserveFill]="true"
                        [iconClass]="'text-secondary'"
                        [url]="
                            zoomIconSizeValue === IconSizeEnum.small
                                ? assetsPath + '/leaflet/small_stop_icon.svg'
                                : iconStop
                        "
                        [size]="[mapIcons?.[MarkerType.stop]?.size, null]"
                        [anchor]="[mapIcons?.[MarkerType.stop]?.anchor[0], mapIcons?.[MarkerType.stop]?.anchor[1]]"
                        [popupAnchor]="[0, -10]"
                        [forceContentClone]="true">
                    </rwidget-map-icon>
                    <rwidget-map-popup *ngIf="zoomIconSizeValue !== IconSizeEnum.small">
                        <ng-container *ngTemplateOutlet="stopPopupTemplate"></ng-container>
                    </rwidget-map-popup>
                </rwidget-map-marker-group>

                <!-- Favorite Stops -->
                <rwidget-map-marker-group
                    [markers]="favoriteStops"
                    [iconZoomSize]="zoomIconSizeValue"
                    [deleteOld]="true"
                    (markerClicked)="onStopClicked($event)">
                    <rwidget-map-icon
                        [preserveFill]="true"
                        [iconClass]="'text-secondary'"
                        [url]="
                            zoomIconSizeValue === IconSizeEnum.small
                                ? assetsPath + '/leaflet/small_stop_icon.svg'
                                : iconFavoriteStop
                        "
                        [size]="[mapIcons?.[MarkerType.stopFavorite]?.size, null]"
                        [anchor]="[
                            mapIcons?.[MarkerType.stopFavorite]?.anchor[0],
                            mapIcons?.[MarkerType.stopFavorite]?.anchor[1]
                        ]"
                        [popupAnchor]="[0, -10]"
                        [forceContentClone]="true">
                    </rwidget-map-icon>
                    <rwidget-map-popup *ngIf="zoomIconSizeValue !== IconSizeEnum.small">
                        <ng-container *ngTemplateOutlet="stopPopupTemplate"></ng-container>
                    </rwidget-map-popup>
                </rwidget-map-marker-group>
            </ng-container>

            <ng-template #stopPopupTemplate>
                <div class="popup-title text-base">
                    <p>{{ clickedStop?.name }}</p>
                </div>
                <mat-nav-list class="remove-padding">
                    <mat-list-item (click)="onDepartureClicked(clickedStop.name, clickedStop.latlng)">
                        <div mat-line>{{ 'SCHEDULE_SET_AS_DEPARTURE' | translate }}</div>
                        <mat-icon>chevron_right</mat-icon>
                    </mat-list-item>
                    <mat-divider></mat-divider>
                    <mat-list-item (click)="onDestinationClicked(clickedStop.name, clickedStop.latlng)">
                        <div mat-line>{{ 'SCHEDULE_SET_AS_DESTINATION' | translate }}</div>
                        <mat-icon>chevron_right</mat-icon>
                    </mat-list-item>
                </mat-nav-list>
            </ng-template>
        </rwidget-map-layer-group>

        <rwidget-map-locator></rwidget-map-locator>
    </rwidget-map>
</ng-template>
